import Axios from 'axios';
import store from '../store';

const apiUrl = process.env.VUE_APP_CONTROL_API_URL.replace(/\/$/, '');

const http = Axios;
http.defaults.withCredentials = true;

const clearAuthenticationState = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('username');
  delete http.defaults.headers.common['Authorization'];
  store.commit('user/logout');
};

const isRefreshRequest = config => config && (
  config.skipAuthRefresh || /\/authenticate\/refresh(?:[/?#]|$)/.test(config.url || '')
);

const rejectAfterRefreshFailure = error => {
  clearAuthenticationState();
  window.location.href = `${apiUrl}/authenticate`;
  return Promise.reject(error);
};

http.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    // config.headers['Content-Type'] = 'application/json';
    return config;
  },
  error => {
    Promise.reject(error)
  });

http.interceptors.response.use((response) => {
  return response
},
  function (error) {
    const originalRequest = error.config || {};

    if (isRefreshRequest(originalRequest)) {
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      console.log('Refreshing token');
      return http.post(`${apiUrl}/authenticate/refresh`,
        {
          "refresh_token": localStorage.getItem('refreshToken')
        },
        {
          skipAuthRefresh: true
        })
        .then(res => {
          if (res.status !== 201) {
            return rejectAfterRefreshFailure(new Error('Unexpected refresh token response'));
          }

          // 1) put token to LocalStorage
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('refreshToken', res.data.refreshToken);
          localStorage.setItem('username', res.data.username)

          // 2) Change Authorization header
          http.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.token;

          // 3) return originalRequest object with Axios.
          return http(originalRequest);
        }, rejectAfterRefreshFailure)
    }
    // return Error object with Promise
    return Promise.reject(error);
  });

export { apiUrl, http, clearAuthenticationState };
